import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {Grid} from "@material-ui/core";
import {Stepper} from "../../components/Stepper/Stepper";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {NavigationButtons} from "../../components/NavigationButtons/NavigationButtons";
import {useFormik} from "formik";
import {AddFieldTemplateDialog} from "../../components/AddFieldTemplateDialog/AddFieldTemplateDialog";
import {useDialog} from "../../hooks/useDialog";
import {FakeFieldGrid} from "../../components/FakeFieldGrid/FakeFieldGrid";
import {DynamicFields, generateSteps} from "../../utils/dynamicFields";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {useDispatch, useSelector} from "react-redux";
import {changeActTemplate, getActTemplate, loadingActTemplate, setActTemplateValues} from "../../redux/reducers/act-template-reducer";
import {getActiveEnvironmentState, loadingActiveEnvironmentState} from "../../redux/reducers/master-of-acts-reducer";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FakeFieldScheme } from '../../components/FakeFieldGrid/FakeFridScheme';
import { getProjectsId } from '../../redux/reducers/project-reducer';


const useStyles = makeStyles((theme) => ({
    container: {
        flexWrap: 'nowrap',
        height: '100%'
    },
    stepContainer: {
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        flexGrow: 2,
    },
    stepContainerScheme: {
        marginTop: '85px',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        flexGrow: 2,
    },
    footerContainer: {
        marginTop: theme.spacing(2),
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(3),

    },
    smallButtonLabel: {
        fontSize: '1.125rem',
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '0.00714em',
        textTransform: 'none',
        display: 'inline'
    }
}))


export const ActTemplateEdit = () => {
    const classes = useStyles()

    const {projectID} = useParams()

    const activeEnvironmentState = useSelector(getActiveEnvironmentState)
    const getProject = useSelector(getProjectsId)
    const {actTemplate, loading} = useSelector(getActTemplate)

    const {values, setFieldValue, getFieldProps, setValues} = useFormik({
        initialValues: {
            content: {
                stepperConfig: ["", "", ""],
            },
            fieldTemplates: []
        }
    })
    const [activeStep, setActiveStep] = useState(0)
    const {open, handleOpen, handleClose} = useDialog()
    const [selectedFieldTemplateIndex, setSelectedFieldTemplateIndex] = useState(null)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setActTemplateValues(values))
    },[values])

    const handleAddButtonClick = () => {
        setSelectedFieldTemplateIndex(null)
        handleOpen()
    }


    const handleAddFieldTemplate = (fieldTemplate) => {
        setFieldValue(`fieldTemplates[${activeStep}]`, [...values.fieldTemplates[activeStep], {
            ...fieldTemplate,
            step: activeStep,
            sequenceNumber: values.fieldTemplates[activeStep].length + 1
        }])
        if (fieldTemplate.type === DynamicFields.SELECTED_OFFENSE_LIST) {
            setFieldValue(`content.violationsVariable`, fieldTemplate.variable)
        }
        handleClose()
    }

    const handleFieldTemplateChange = (fieldTemplate) => {
        setFieldValue(`fieldTemplates[${activeStep}]`, values.fieldTemplates[activeStep].map((el, i) => {
            if (i === selectedFieldTemplateIndex) {
                return fieldTemplate
            }
            return el
        }))
        if (fieldTemplate.type === DynamicFields.SELECTED_OFFENSE_LIST) {
            setFieldValue(`content.violationsVariable`, fieldTemplate.variable)
        }
        handleClose()
    }

    const handleSequenceNumberChange = (newFieldTemplates) => {
        setFieldValue(`fieldTemplates[${activeStep}]`, newFieldTemplates)
    }

    const handleFieldTemplateClick = async (index) => {
        setSelectedFieldTemplateIndex(index)
        handleOpen()
    }

    useEffect(() => {
        dispatch(loadingActiveEnvironmentState(projectID))
    }, [projectID])

    useEffect(() => {
        if (activeEnvironmentState && activeEnvironmentState?.act_template) {
            dispatch(loadingActTemplate(activeEnvironmentState.act_template))
        }
    }, [activeEnvironmentState])

    useEffect(() => {
        if (actTemplate) {
            setValues({...actTemplate, fieldTemplates: generateSteps(actTemplate.fieldTemplates)})
        }
    }, [actTemplate])

    const handleFieldTemplateDelete = (deletedField, newFieldTemplates) => {
        setFieldValue(`fieldTemplates[${activeStep}]`, newFieldTemplates)
        if (deletedField.type === DynamicFields.SELECTED_OFFENSE_LIST) {
            setFieldValue(`content.violationsVariable`, '')
        }
    }

    const handleSave = () => {
        dispatch(changeActTemplate(values))
    }


    if (loading 
            || !values || getProject?.id !== actTemplate?.project || activeEnvironmentState?.project !== getProject?.id 
            || !activeEnvironmentState?.is_active
            ) 
        return (
            <Grid container className={classes.container} justifyContent={"center"} alignItems={"center"}>
                <Grid item>
                    <CircularProgress />
                </Grid>
            </Grid>
        )


    return <Grid container direction={'column'} className={classes.container}>
        <Grid item>
            <Stepper activeStep={activeStep} stepNames={values.content.stepperConfig}/>
        </Grid>
        <Grid item container direction={"row"} className={classes.container}>
            <Grid item container direction={"column"} className={classes.stepContainer}>
                <Grid item>
                    <TextField label={'Название шага'}
                            variant={"outlined"}
                            size={"small"}
                            {...getFieldProps(`content.stepperConfig[${activeStep}]`)}
                    />
                </Grid>
                    <FakeFieldGrid fakeFields={values.fieldTemplates[activeStep] || []}
                            handleAddButtonClick={handleAddButtonClick}
                            handleFieldTemplateDelete={handleFieldTemplateDelete}
                            handleSequenceNumberChange={handleSequenceNumberChange}
                            handleFieldTemplateClick={handleFieldTemplateClick}
                            setFieldValue={setFieldValue}
                            activeStep={activeStep}
                            getFieldProps={getFieldProps}
                    />
            </Grid>
            <Grid item container direction={"column"} className={classes.stepContainerScheme}>
                <FakeFieldScheme
                    fakeFields={values.fieldTemplates[activeStep] || []}
                />
            </Grid>
        </Grid>

        <Grid item container className={classes.footerContainer} justifyContent={'space-between'}>
            <NavigationButtons activeStep={activeStep}
                               nextStep={() => setActiveStep((prev) => ++prev)}
                               prevStep={() => setActiveStep((prev) => --prev)}
            />
            <Grid item>
                <form>
                    <Button onClick={handleSave}
                        variant={"contained"}
                        size={"small"}>
                    <Typography variant={'body1'}
                                classes={{body1: classes.smallButtonLabel}}
                    >
                        Сохранить
                    </Typography>
                    </Button>
                </form>
                
            </Grid>
        </Grid>
        <AddFieldTemplateDialog open={open}
                                handleClose={handleClose}
                                handleSave={handleAddFieldTemplate}
                                selectedFieldTemplate={selectedFieldTemplateIndex !== null ?
                                    values.fieldTemplates[activeStep][selectedFieldTemplateIndex] : null}
                                handleFieldTemplateChange={handleFieldTemplateChange}
        />
    </Grid>
}